import React from 'react';
import { Heart, Bell, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../assets/css/donordashboard/DonorTopBar.css';

const DonorTopBar = () => {
  const navigate = useNavigate();

  const handleDonateNow = () => {
    navigate('/donor/donate-now');
  };

  const handleProfileClick = () => {
    navigate('/donor/profile');
  };

  const handleNotificationClick = () => {
    // Notification panel open karo yahan
    console.log('Notifications clicked');
  };

  return (
    <div className="donor-top-bar">

      {/* Left Side - Logo */}
      {/* FIX: "m-top-bar-logo" class use ki CSS ke saath match karne ke liye */}
      <div className="D-top-bar-left">
        <div className="m-top-bar-logo">
          <Heart className="m-logo-heart-icon" size={32} />
          <span className="m-logo-title">SDMS</span>
        </div>
      </div>

      {/* Right Side - Buttons */}
      <div className="m-top-bar-right">

        {/* FIX: Bell Notification Icon add kiya (screenshot mein tha, code mein missing tha) */}
        <div className="notification-wrapper" onClick={handleNotificationClick}>
          <Bell size={22} />
          <span className="notif-badge">3</span>
        </div>

        {/* FIX: Profile Icon add kiya (screenshot mein tha, code mein missing tha) */}
        <button className="profile-icon-btn" onClick={handleProfileClick}>
          <User size={22} />
        </button>

        {/* Donate Now Button */}
        {/* <button className="donate-button" onClick={handleDonateNow}>
          <Heart size={18} />
          <span>Donate Now</span>
        </button> */}

        {/* User Button */}
        {/* <button className="m-user-button" onClick={handleProfileClick}>
          <div className="m-user-avatar">MI</div>
          <span className="m-user">M Imran</span>
        </button> */}

      </div>
    </div>
  );
};

export default DonorTopBar;